import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import {
  LogoutUser,
  getbroadcastmessageforuser,
} from "../../Services/Admin/Addmin";
import { fDateTime } from "../../Utils/Date_format/datefromat";
import { getCompanyApi, getAllClient } from "../../Services/Superadmin/Superadmin";
import { user_header } from "./Sidebar_path";
import * as Icons from "lucide-react";
import { getUserFromToken } from "../../Utils/TokenVerify";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getNotificationMessagedata, getpaymenthistorydata, getINRpaymenthistoryforSuperadmin, getSuperadminpaymenthistorydata, GetINRpaymenthistoryforadmin } from "../../Services/Admin/Addmin";
import { io } from "socket.io-client";
import * as Config from "../../Utils/Config";
import Swal from "sweetalert2";

const Header = () => {



  // const storedMarket = JSON.parse(sessionStorage.getItem("market")) || [0];
  // const market = storedMarket.length === 1 ? storedMarket[0] : storedMarket;

  const navigate = useNavigate()

  const location = useLocation();
  const TokenData = getUserFromToken();
  const user_role = TokenData?.Role?.toUpperCase();
  const user_id = TokenData?.user_id;
  const exp = TokenData?.exp;


  const [isActive, setIsActive] = useState(false);
  const [notification, setNotification] = useState([]);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const [logo, setLogo] = useState("");
  const [client, setClient] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [unreadCount1, setUnreadCount1] = useState(0);
  const [supernotification, setSupernotification] = useState([])
  const [socket, setSocket] = useState(null);
  const [tradingStatus, setTradingStatus] = useState("checking");

  const fetchTradingStatus = async () => {
    if (user_role !== "SUPERADMIN") return;
    try {
      const data = { userid: user_id };
      const response = await getCompanyApi(data);
      if (response.status) {
        const clientData = response.data;
        if (clientData.access_token && clientData.access_token.length > 15) {
          setTradingStatus("connected");
        } else {
          setTradingStatus("disconnected");
        }
      } else {
        setTradingStatus("disconnected");
      }
    } catch (error) {
      setTradingStatus("disconnected");
    }
  };

  useEffect(() => {
    fetchTradingStatus();
  }, [user_id, user_role, location.pathname]);

  useEffect(() => {
    const s_url = Config.getSocketUrlWeb();
    const isLocalhost = window.location.hostname === "localhost";
    const newSocket = io(s_url, {
      path: isLocalhost ? "/socket.io" : "/backend/socket.io",
      transports: ["polling", "websocket"],
      reconnection: true,
      rejectUnauthorized: false,
    });
    setSocket(newSocket);
    
    return () => {
      newSocket.disconnect();
    };
  }, [logo]); // re-run socket initialization if logo (and hence socket_port) is updated

  useEffect(() => {
    if (!socket) return;
    
    const handlePayment = (data) => {
      if (data.adminid === user_id) fetchAllNotifications();
      gethistorysuperadmin();
    };
    
    const handleMessage = (data) => {
      if (data.parent_id === user_id) fetchAllNotifications();
    };

    socket.on("newPaymentRequest", handlePayment);
    socket.on("newMessage", handleMessage);

    return () => {
      socket.off("newPaymentRequest", handlePayment);
      socket.off("newMessage", handleMessage);
    };
  }, [socket, user_id]);



  const getallclient = async () => {
    try {
      const data = { userid: user_id };
      const response = await getAllClient(data);
      if (response.status) {
        setClient(response.data);
      }
    } catch (error) { }
  };




  useEffect(() => {
    fetchLogo();
    getallclient();
  }, []);

  useEffect(() => {
    if (client?.ActiveStatus == 0) {
      logoutuser()
    }
  }, [client])



  useEffect(() => {
    if (user_id) fetchAllNotifications()
    gethistorysuperadmin()
  }, [user_id]);



  useEffect(() => {
    const timeLeft = exp * 1000 - Date.now();
    if (timeLeft <= 0) return logoutuser();
    const timeout = setTimeout(logoutuser, timeLeft);
    return () => clearTimeout(timeout);
  }, [exp]);



  const fetchAllNotifications = async () => {
    try {
      const msgData = await getNotificationMessagedata({ adminId: user_id });
      const messages = msgData.status ? msgData?.messages.map((item) => ({
        id: item._id,
        type: "message",
        message: item.message,
        timestamp: item.timestamp,
        senderName: item.senderName,
        senderType: "",
      })) : [];

      // Payments
      const payData = await getpaymenthistorydata({ adminid: user_id });
      const payments = payData.status ? payData.data.map((item) => ({
        id: item._id,
        type: item.type,
        message: `Transaction Request : $${item.Balance} From ${item.userName}`,
        timestamp: item.createdAt,
        senderName: item.UserName,
        status: item.status,
        sign: "dollar"
      })) : [];


      const INRpayData = await GetINRpaymenthistoryforadmin({ adminid: user_id });
      const INRpayments = INRpayData.status ? INRpayData.data.map((item) => ({
        id: item._id,
        type: item.type,
        message: `Transaction Request : ₹${item.Balance} From ${item.userName}`,
        timestamp: item.createdAt,
        senderName: item.UserName,
        status: item.status,
        sign: "rupee"
      })) : [];


      const combined = [...messages, ...payments, ...INRpayments].sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
      );

      setNotification(combined);
      setUnreadCount(combined.length);

    } catch (error) {
      console.log("Error fetching notifications:", error);
    }
  };


  const gethistorysuperadmin = async () => {
    try {
      const data = { adminid: user_id };
      const response = await getSuperadminpaymenthistorydata(data);
      if (response.status) {
        const payments = response.status ? response.data.map((item) => ({
          id: item._id,
          type: item.type,
          message: `Transaction Request :  $${item.Balance} to ${item.AdminName}`,
          timestamp: item.createdAt,
          senderName: "",
          status: item.status,
          adminName: item.AdminName

        })) : [];

        const INRpayData = await getINRpaymenthistoryforSuperadmin({ adminid: user_id });
        const INRpayments = INRpayData.status ? INRpayData.data.map((item) => ({
          id: item._id,
          type: item.type,
          message: `Transaction Request : ₹${item.Balance} to ${item.AdminName}`,
          timestamp: item.createdAt,
          senderName: "",
          status: item.status,
          sign: "rupee"
        })) : [];

        const combined = [...payments, ...INRpayments].sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
        );
        setSupernotification(combined);
        setUnreadCount1(combined.length);
      }
    } catch (error) { }
  }







  useEffect(() => {
    document.body.setAttribute("data-theme-version", theme);
    document.body.className = theme === "dark" ? "dark-mode" : "light-mode";
  }, [theme]);



  useEffect(() => {
    const element = document.querySelector(".wallet-open.show");

    if (element) {
      if (isActive) {
        element.classList.add("menu-toggle");
      } else {
        element.classList.remove("menu-toggle");
      }
    } else {
    }
  }, [isActive]);



  useEffect(() => {
    const handleBodyClick = (e) => {
      // Close sidebar on mobile if clicked outside nav/sidebar
      if (window.innerWidth <= 768 && isActive) {
        if (e.target.closest('.content-body')) {
          setIsActive(false);
        }
      }
    };
    document.addEventListener("click", handleBodyClick);
    return () => document.removeEventListener("click", handleBodyClick);
  }, [isActive]);

  const changeFavicon = (iconPath) => {
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = iconPath;
  };



  const fetchLogo = async () => {
    const res = await getCompanyApi();
    if (res && res.data) {
      setLogo(res.data.logo);
      changeFavicon(res.data.favicon);
      localStorage.setItem("Port", res?.data?.port);
      localStorage.setItem("socket_port", res?.data?.socket_port);
      document.title = res.data.panelName;

      // Update global Live Datafeed socket Client URL
      import("../../Utils/socketClient").then((module) => {
        const globalSocket = module.default;
        if (globalSocket.disconnected) {
          globalSocket.connect();
        }
      });
    }
  };




  const toggleHamburger = () => {
    setIsActive((prev) => !prev);
    const element = document.querySelector(".wallet-open.show.active");

    if (element) {
      element.classList.toggle("menu-toggle");
    } else {
    }
  };




  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";

    document.body.setAttribute("data-theme-version", newTheme);
    document.body.className = newTheme === "dark" ? "dark-mode" : "light-mode";
    document.querySelector(".dz-theme-mode").classList.toggle("active");

    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };




  const logoutuser = async (type) => {
    try {
      if (type === 1) {
        // Confirmation ke saath logout
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "Do you want to logout?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, logout",
          cancelButtonText: "No, stay",
        });

        if (result.isConfirmed) {
          const response = await LogoutUser({ userid: user_id });
          if (response.status) {
            localStorage.clear();
            Swal.fire({
              icon: "success",
              title: "Logged out!",
              text: "You have been logged out successfully.",
              timer: 1500,
              showConfirmButton: false,
            });
            navigate("/login");
          }
        }
      } else {
        // Direct logout without confirmation
        const response = await LogoutUser({ userid: user_id });
        if (response.status) {
          localStorage.clear();
          navigate("/login");
        }
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while logging out.",
      });
    }
  };



  const getLastPathSegment = (path) => {
    const segments = path
      .split("/")
      .filter((segment) => isNaN(segment.charAt(0)));
    return segments[segments.length - 1] || segments[segments.length - 2];
  };




  const formattedSegment =
    getLastPathSegment(location.pathname)?.charAt(0).toUpperCase() +
    getLastPathSegment(location.pathname)?.slice(1);




  const pageTitles = {
    Admin: "Add Admin",
    Addmin: "Add Admin",
    Adduser: "Add User",
    Loginstatus: "Login Status",
    Adminuser: "Admin Users",
    Adminemployee: "Admin Employees",
    Position: "Available Position",
    Tradehistory: "Trade History",
    Holdoff: "Hold Off",
    Changedpassword: "Changed Password",
    Addemployees: "Add Employee",
    Basicsetting: "Basic Settings",
    Alltradehistory: "Trade History",
    PlanSubscription: "Plan Subscription",
    Bankdetails: "Bank Details"
  };

  const title = pageTitles[formattedSegment] || formattedSegment;




  const handleClick = (item) => {
    const basePath = user_role === "ADMIN" ? "/admin" : "/superadmin";

    if (item.type == 0) {
      navigate(`${basePath}/withdrawal`, { state: { item: item.sign } });
    } else if (item.type == 1) {
      navigate(`${basePath}/deposit`, { state: { item: item.sign } });
    } else {
      navigate(`${basePath}/chatbox`);
    }
  };




  const stored = JSON.parse(localStorage.getItem("market")) || [0];
  const isToggleMode = stored.length === 2;

  let market = 0;

  if (!isToggleMode) {
    market = stored[0];
  } else {
    market = Number(localStorage.getItem("currentCurrency")) || 0;
  }



  const toggleCurrency = () => {
    const stored = JSON.parse(localStorage.getItem("market")) || [0];
    if (stored.length === 2) {
      const current = Number(localStorage.getItem("currentCurrency")) || 0;
      const next = current === 0 ? 1 : 0;
      localStorage.setItem("currentCurrency", next);
      window.location.reload();
      return;
    }
    localStorage.setItem("market", JSON.stringify([0, 1]));
    localStorage.setItem("currentCurrency", 0);
    window.location.reload();
  };



  return (
    <>
      <style>
        {`
          @media (max-width: 767px) {
            ${user_role === "USER" ? `
            .nav-control {
              display: none !important;
            }
            .nav-header {
              display: none !important; /* Hide logo/hamburger container completely to free up space */
            }
            .header {
              padding-left: 0 !important;
            }
            ` : ""}
            .header-left, .notification_dropdown:empty {
              display: none !important;
            }
            .header-right {
              display: flex !important;
              flex-direction: row !important;
              justify-content: flex-end !important;
              width: 100% !important;
              padding: 0 15px 0 0 !important; /* Zero left padding */
              margin: 0 !important;
              align-items: center !important;
              gap: 15px !important;
            }
            .mobile-header-title {
              margin-right: auto !important;
              margin-left: -30px !important; /* Huge negative margin to force to the absolute physical edge */
              padding-left: 0 !important;
              position: static !important;
              transform: none !important;
              order: -1 !important;
            }
            .currency-toggle-btn {
              order: 1 !important;
              margin: 0 !important;
            }
            .header-profile-item {
              order: 2 !important; 
            }
            
            /* Reduce overall header height on mobile */
            .header-banner {
              height: 70px !important;
            }
            .header-content {
              padding-top: 5px !important;
              padding-bottom: 5px !important;
              min-height: 60px !important;
            }
            .page-titles {
              padding-top: 0 !important;
              margin-top: 0px !important;
              display: none !important; /* Completely hide page-titles container on mobile to save space */
            }
          }
          
          @media (max-width: 767px) {
            .content-body {
              padding-top: 75px !important; /* Pull content up closer to the new smaller header */
            }
          }
        `}
      </style>
      <div className="main-header">
      <div
        className="header-banner"
        style={{
          backgroundImage: "url(/assets/images/bg-1.png)",

        }}
      ></div>


      <div className="nav-header">
        <a href="" className="">
          <img
            src={logo}
            style={{ maxWidth: "250px", width: "100%", height: "auto", maxHeight: "83px", objectFit: "contain" }}
            alt="Logo"
          />

          <div className="brand-title"></div>
        </a>

        <div className="nav-control">
          <div
            className={`hamburger ${isActive ? "is-active" : ""}`}
            onClick={toggleHamburger}
          >
            <span className="line" />
            <span className="line" />
            <span className="line" />
          </div>
        </div>
      </div>

      <div className="header home">
        <div className="header-content">
          <nav className="navbar navbar-expand">
            <div className="collapse navbar-collapse justify-content-between">
              <div className="header-left"></div>
              <ul className="navbar-nav header-right">
                <li className="nav-item dropdown notification_dropdown">
                  {/* <a className="nav-link dz-theme-mode" onClick={toggleTheme}>...</a> */}
                </li>

                {/* Mobile Title (Centered) */}
                <li 
                  className="mobile-header-title d-block d-md-none fw-bold text-white" 
                  style={{ 
                    position: 'absolute', 
                    left: '50%', 
                    transform: 'translateX(-50%)', 
                    fontSize: '1.2rem', 
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none'
                  }}
                >
                  {title}
                </li>

                {user_role === "USER" && isToggleMode && (
                  <button
                    onClick={toggleCurrency}
                    className="btn btn-outline-dark d-flex align-items-center gap-2 px-3 py-1 currency-toggle-btn"
                    style={{ borderRadius: "25px" }}
                  >
                    <span style={{ fontWeight: 600, fontSize: "14px", color: "#fff" }}>
                      {market === 0 ? "USD" : "INR"}
                    </span>

                    <div
                      style={{
                        width: 40,
                        height: 20,
                        borderRadius: 20,
                        background: market === 0 ? "#007bff" : "#28a745",
                        position: "relative",
                        transition: "0.3s",
                      }}
                    >
                      <div
                        style={{
                          width: 18,
                          height: 18,
                          background: "#fff",
                          borderRadius: "50%",
                          position: "absolute",
                          top: 1,
                          left: market === 0 ? 21 : 1,
                          transition: "0.3s",
                        }}
                      />
                    </div>
                  </button>
                )}


                {user_role === "ADMIN" && (
                  <li className="nav-item dropdown notification_dropdown">
                    <a
                      href="#"
                      className="nav-link"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="fa fa-bell" style={{ color: "white" }} />  {unreadCount > 0 && (
                        <span className="badge bg-danger position-absolute top-0 start-100 translate-middle">
                          {unreadCount}
                        </span>
                      )}
                    </a>
                    <div className="dropdown-menu dropdown-menu-end p-0 shadow-lg border-0"
                      style={{ width: "340px", borderRadius: "10px", overflow: "hidden" }}>

                      <div className="p-3 border-bottom bg-light fw-bold">
                        Notifications
                      </div>
                      <div
                        id="DZ_W_Notification3"
                        className="widget-media dlab-scroll "
                        style={{ maxHeight: 380, overflowY: "auto" }}
                      >
                        <ul className="timeline">
                          {notification?.length == 0 ? (
                            <p className="text-center text-muted">
                              No new notifications
                            </p>
                          ) : (
                            <div className="notification-dropdown">
                              <ul className="list-unstyled mt-2">
                                {notification?.map((item) => (
                                  <li key={item._id} >
                                    <div className="timeline-panel" onClick={() => handleClick(item)}
                                      style={{ cursor: "pointer" }}>
                                      <div className="media me-2">
                                        <img
                                          alt={`Avatar of ${item.senderName}`}
                                          width={40}
                                          src="/assets/images/avatar/1.png"
                                        />
                                      </div>
                                      <div className="media-body">
                                        <h6 className="mb-1">{item.message}</h6>
                                        <small className="d-block">{fDateTime(item.timestamp)}</small>
                                      </div>
                                      <h6 className="mb-4">{item.senderName}</h6>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>

                          )}
                        </ul>
                      </div>

                    </div>
                  </li>
                )}
                {user_role === "SUPERADMIN" && (
                  <>
                    <li className="nav-item me-3 d-flex align-items-center">
                      <Link
                        to="/superadmin/broker-details?tab=redirect"
                        className="btn btn-warning btn-sm fw-bold text-dark d-flex align-items-center gap-2"
                        style={{ borderRadius: "20px", padding: "6px 15px", whiteSpace: "nowrap" }}
                      >
                        <i className="fas fa-play-circle" />
                        <span>Trading</span>
                        {tradingStatus === "connected" ? (
                          <span className="badge bg-success text-white" style={{ fontSize: "10px", borderRadius: "10px", padding: "3px 8px" }}>ON</span>
                        ) : (
                          <span className="badge bg-danger text-white" style={{ fontSize: "10px", borderRadius: "10px", padding: "3px 8px" }}>OFF</span>
                        )}
                      </Link>
                    </li>
                    <li className="nav-item dropdown notification_dropdown">
                      <a
                        href="#"
                      className="nav-link"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="fa fa-bell" style={{ color: "white" }} />  {unreadCount1 > 0 && (
                        <span className="badge bg-danger position-absolute top-0 start-100 translate-middle">
                          {unreadCount1}
                        </span>
                      )}
                    </a>
                    {/* <div className="dropdown-menu dropdown-menu-end of-visible">
                      <div
                        id="DZ_W_Notification3"
                        className="widget-media dlab-scroll mt-2"
                        style={{ maxHeight: 380, overflowY: "auto" }}
                      >
                        <ul className="timeline" style={{padding: "6px"}}>
                          {supernotification?.length == 0 ? (
                            <p className="text-center text-muted">
                              No new notifications
                            </p>
                          ) : (
                            <div className="notification-dropdown">
                              <ul className="list-unstyled mt-2">
                                {supernotification?.map((item) => (
                                  <li key={item._id} >
                                    <div className="timeline-panel" onClick={() => handleClick(item)}
                                      style={{ cursor: "pointer" }}>
                                      <div className="media me-2">
                                        <img
                                          alt={`Avatar of ${item.adminName}`}
                                          width={40}
                                          src="/assets/images/avatar/1.png"
                                        />
                                      </div>
                                      <div className="media-body">
                                        <h6 className="mb-1">{item.message}</h6>
                                        <small className="d-block">{fDateTime(item.timestamp)}</small>
                                      </div>
                                      <h6 className="mb-4">{item.senderName}</h6>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>

                          )}
                        </ul>
                      </div>

                    </div> */}
                    <div className="dropdown-menu dropdown-menu-end p-0 shadow-lg border-0"
                      style={{ width: "340px", borderRadius: "10px", overflow: "hidden" }}>

                      <div className="p-3 border-bottom bg-light fw-bold">
                        Notifications
                      </div>

                      <div
                        id="DZ_W_Notification3"
                        className="notification-scroll"
                        style={{ maxHeight: 350, overflowY: "auto" }}
                      >
                        {supernotification?.length === 0 ? (
                          <p className="text-center text-muted py-3">No new notifications</p>
                        ) : (
                          <ul className="list-unstyled m-0">
                            {supernotification?.map((item) => (
                              <li
                                key={item._id}
                                className="d-flex align-items-start p-3 border-bottom notification-item"
                                onClick={() => handleClick(item)}
                                style={{ cursor: "pointer", transition: "0.2s" }}
                              >
                                <img
                                  alt={item.adminName}
                                  width="45"
                                  height="45"
                                  className="rounded-circle me-3"
                                  src="/assets/images/avatar/1.png"
                                />

                                <div className="flex-grow-1">
                                  <h6 className="mb-1 text-dark">{item.message}</h6>
                                  <small className="text-muted">{fDateTime(item.timestamp)}</small>
                                </div>

                                <div className="ms-2">
                                  <small className="text-primary fw-bold">{item.senderName}</small>
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                  </li>
                </>
              )}
                <li className="header-profile-item">
                  <div className="dropdown header-profile2">
                    <a
                      className="nav-link"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <div className="header-info2 d-flex align-items-center">
                        <img src="/assets/images/avatar/1.png" alt="" />
                      </div>
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      {user_role === "ADMIN" && (
                        <Link
                          to="/admin/profile"
                          className="dropdown-item ai-icon"
                        >
                          <i
                            className="fas fa-user"
                            style={{ fontSize: "18px", color: "#000" }}
                          />
                          <span className="ms-2">Profile</span>
                        </Link>
                      )}
                      {user_role === "EMPLOYE" && (
                        <Link
                          to="/employee/profile"
                          className="dropdown-item ai-icon"
                        >
                          <i
                            className="fas fa-user"
                            style={{ fontSize: "18px", color: "#000" }}
                          />
                          <span className="ms-2">Profile</span>
                        </Link>
                      )}
                      {user_role === "ADMIN" && (
                        <>
                          <Link
                            to="/admin/bankdetails"
                            className="dropdown-item ai-icon"
                          >
                            <i
                              className="fas fa-university"
                              style={{ fontSize: "18px", color: "#000" }}
                            />
                            <span className="ms-2">Bank Details</span>
                          </Link>


                        </>
                      )}
                      {user_role === "ADMIN" && (
                        <Link
                          to="/admin/basicsetting"
                          className="dropdown-item ai-icon"
                        >
                          <i
                            className="fas fa-cog"
                            style={{ fontSize: "18px", color: "#000" }}
                          />
                          <span className="ms-2">Basic Setting</span>
                        </Link>
                      )}
                      {user_role === "ADMIN" && (
                        <Link
                          to="/admin/planSubscription"
                          className="dropdown-item ai-icon"
                        >
                          <i
                            className="fas fa-cog"
                            style={{ fontSize: "18px", color: "#000" }}
                          />
                          <span className="ms-2">Plan</span>
                        </Link>
                      )}

                      {user_role === "SUPERADMIN" && (
                        <>
                          <Link
                            to="/superadmin/system"
                            className="dropdown-item ai-icon"
                          >
                            <i
                              className="fas fa-cogs"
                              style={{ fontSize: "18px", color: "#000" }}
                            />
                            <span className="ms-2">System</span>
                          </Link>
                          <Link
                            to="/superadmin/email-details"
                            className="dropdown-item ai-icon"
                          >
                            <i
                              className="fas fa-envelope"
                              style={{ fontSize: "18px", color: "#000" }}
                            />
                            <span className="ms-2">Email Details</span>
                          </Link>
                          <Link
                            to="/superadmin/settings"
                            className="dropdown-item ai-icon"
                          >
                            <i
                              className="fas fa-sliders-h"
                              style={{ fontSize: "18px", color: "#000" }}
                            />
                            <span className="ms-2">settings</span>
                          </Link>
                          <Link
                            to="/superadmin/broker-details"
                            className="dropdown-item ai-icon"
                          >
                            <i className="fas fa-exchange-alt" style={{ fontSize: "18px", color: "#000" }} />
                            <span className="ms-2">Broker</span>
                          </Link>

                        </>

                      )}
                      {user_role === "SUPERADMIN" && (
                        <Link
                          to={`/superadmin/google-login`}
                          className="dropdown-item ai-icon"
                        >
                          <i
                            className="fas fa-lock"
                            style={{ fontSize: "18px", color: "#000" }}
                          />
                          <span className="ms-2">google Login</span>
                        </Link>
                      )}
                      {(user_role === "ADMIN" || user_role === "EMPLOYE") && (
                        <Link
                          to={`/${user_role === "ADMIN" ? "admin" : "employee"
                            }/changedpassword`}
                          className="dropdown-item ai-icon"
                        >
                          <i
                            className="fas fa-lock"
                            style={{ fontSize: "18px", color: "#000" }}
                          />
                          <span className="ms-2">Change Password</span>
                        </Link>
                      )}
                      {user_role === "USER" && (
                        <Link
                          to="/user/profile"
                          className="dropdown-item ai-icon"
                        >
                          <i
                            className="fas fa-user"
                            style={{ fontSize: "18px", color: "#000" }}
                          />
                          <span className="ms-2">Profile</span>
                        </Link>
                      )}

                      {user_role !== "USER" && (
                      <div
                        to="/login"
                        className="dropdown-item ai-icon"
                        onClick={() => logoutuser(1)}

                      >
                        <i
                          className="fas fa-sign-out-alt"
                          style={{ fontSize: "20px", color: "#fd5353" }}
                        />
                        <span className="ms-2 text-danger" style={{ fontSize: "16px" }}>Logout</span>
                      </div>
                      )}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
        </div>
        <div className="page-titles ">
          <div className="sub-dz-head">
            <div className="d-flex align-items-center dz-head-title">
              <h2 className="text-white m-4">{title}</h2>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
    </>
  );
};

export default Header;
